module.exports = __webpack_public_path__ + "img/05-2第三个3年.44e13f08.png";